import { Dropdown } from "../Dropdown";
import { Icon } from "../Icon";
import { LiveIndicator } from "../LiveIndicator";
import { SubtleButton } from "../SubtleButton";
import { Tooltip } from "../Tooltip";
import type { BranchData, BranchSummary } from "../Workflow";

export function CreateBranchDropdown({
  currentBranch,
  liveBranch,
  canWrite,
  onFork,
}: {
  currentBranch: BranchData;
  liveBranch?: BranchSummary;
  canWrite: boolean;
  onFork: (branch: BranchData | BranchSummary) => void;
}) {
  const opener = (
    <Tooltip content="Create branch">
      <SubtleButton
        aria-label="Create branch"
        aria-haspopup="menu"
        icon="plus"
        variant="secondary"
        disabled={!canWrite}
      />
    </Tooltip>
  );

  if (!canWrite) return opener;

  return (
    <Dropdown
      opener={opener}
      align="right"
      margin="0 8px"
      maxWidth={240}
      sections={[
        {
          items: [
            ...(liveBranch
              ? [
                  {
                    type: "button" as const,
                    label: "Branch from live",
                    left: <LiveIndicator />,
                    onClick: () => onFork(liveBranch),
                  },
                ]
              : []),
            ...(currentBranch.name !== "main"
              ? [
                  {
                    type: "button" as const,
                    label: "Branch from current branch",
                    left: <Icon name="git-branch" size={16} />,
                    onClick: () => onFork(currentBranch),
                  },
                ]
              : []),
          ],
        },
      ]}
    />
  );
}
